import { defineAction } from '~/prix'
import inventoryCreateAction from './inventoryCreate.action.json' with { type: 'json' }

import { z } from 'zod'
import { inventoryObject } from '../inventoryObject'

const inventoryCreateDefinition = defineAction({
  ...inventoryCreateAction,

  input: inventoryObject.pick({
    id: true,
    residenceId: true,
    equipmentName: true,
    observation: true,
    serialNumber: true,
    createdAt: true,
    updatedAt: true,
  }),
  output: z.object({}),
})

export default inventoryCreateDefinition
